import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { DiscountsRouteNames, DiscountsRoutePathNames } from '../../enums';
import { beforeEnter } from '../guards/index';

const Create = () => import('./Create.vue');

export const createRoute: RouteRecordRaw = {
  path: buildChildURL(DiscountsRoutePathNames.CREATE),
  name: DiscountsRouteNames.DISCOUNTS_CREATE,
  component: Create,
  beforeEnter: beforeEnter,
};
